import {Injectable} from '@angular/core';
import {ProfessionType} from '../model/profession-type.model';
import {Profession} from '../model/profession.model';
import {ProfessionService} from '../service/profession.service';

@Injectable()
export class ProfessionInteractor {
    constructor(private readonly professionService: ProfessionService) {

    }

    public async getByType(professionType: ProfessionType): Promise<Profession[]> {
        const professions = await this.professionService.getAllProfessions();
        return professions.filter(p => p.employeeType === professionType);
    }
}


